// extracted by mini-css-extract-plugin
module.exports = {"counterTitle":"Timer_counterTitle__2V0Ew","counter":"Timer_counter__3ADMC"};